import React from 'react';
import { Mail, Phone, MapPin, Clock, Linkedin } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Products', href: '#products' },
    { name: 'Services', href: '#services' },
    { name: 'Industries', href: '#industries' },
    { name: 'Contact', href: '#contact' }
  ];

  const productLinks = [
    'Stainless Steel Pipes',
    'Sheets & Plates',
    'Round Bars',
    'Flanges & Fittings',
    'Nickel Alloys',
    'Duplex Steel'
  ];

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-1">
              <h3 className="text-2xl font-bold text-white mb-6">
                JPS Metal & Alloys
              </h3>
              <p className="text-slate-300 mb-6 leading-relaxed">
                {companyInfo.description}
              </p>
              
              {/* LinkedIn Link */}
              <div className="flex space-x-4">
                <a
                  href="https://www.linkedin.com/company/jps-metal-alloys"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300"
                  aria-label="LinkedIn"
                >
                  <Linkedin className="h-5 w-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href} 
                      className="text-slate-300 hover:text-white transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Products */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6">Our Products</h4>
              <ul className="space-y-3">
                {productLinks.map((product) => (
                  <li key={product}>
                    <a 
                      href="#products" 
                      className="text-slate-300 hover:text-white transition-colors duration-200"
                    >
                      {product}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-6">Contact Us</h4>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-blue-400 mt-1 flex-shrink-0" />
                  <div className="text-slate-300 text-sm">
                    <div>{companyInfo.address.line1}</div>
                    <div>{companyInfo.address.line2}</div>
                    <div>{companyInfo.address.line3}</div>
                    <div>{companyInfo.address.city}</div>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <Phone className="h-5 w-5 text-blue-400" />
                  <a 
                    href={`tel:${companyInfo.phone}`}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {companyInfo.phone}
                  </a>
                </div>

                <div className="flex items-center space-x-3">
                  <Mail className="h-5 w-5 text-blue-400" />
                  <a 
                    href={`mailto:${companyInfo.email}`}
                    className="text-slate-300 hover:text-white transition-colors"
                  >
                    {companyInfo.email}
                  </a>
                </div>

                <div className="flex items-center space-x-3">
                  <Clock className="h-5 w-5 text-blue-400" />
                  <span className="text-slate-300 text-sm">
                    Mon - Sat: 9:00 AM - 6:00 PM
                  </span>
                </div>
              </div>

              {/* WhatsApp CTA */}
              <Button 
                className="w-full mt-6 bg-green-600 hover:bg-green-700 text-white"
                onClick={() => window.open(companyInfo.whatsapp, '_blank')}
              >
                WhatsApp Quick Quote
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800 py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center space-y-4">
            <div className="text-slate-400 text-sm">
              © {currentYear} JPS Metal & Alloys. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};